import { styled } from '@mui/material/styles';

const PREFIX = 'RowLabelTooltip';

export const classes = {
  tooltip: `${PREFIX}-tooltip`,
  title: `${PREFIX}-title`,
};

export const Root = styled('span')({
  [`&.${classes.title}`]: {
    cursor: 'cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  },
});